import { Link, NavLink } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { NAV_LINKS } from './nav';

// The ink underline that grows in from the left on hover (and stays on the
// current page).
const UNDERLINE = 'absolute bottom-0 left-0 w-full h-0.5 bg-[var(--color-ink-main)] transform origin-left transition-transform duration-300';

// Shared header for the marketing pages: logo, the site's pages, Login.
// The logo link and its absolute image path are what the prerendered pages
// (src/prerender.js) rely on to still resolve from /terms/ or /install/.
function SiteHeader() {
  return (
    <nav className="px-4 md:px-8 pt-6 pb-4 max-w-7xl mx-auto flex items-center justify-between gap-3" aria-label="Site">
      <Link to="/" className="flex items-center gap-3 group flex-shrink-0">
        <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-[var(--color-surface-card)] rounded-xl md:rounded-2xl shadow-sm border border-[var(--color-divider)] p-1 transition-all duration-500 group-hover:rotate-6 group-hover:scale-110">
          <img src="/android-chrome-192x192.png" alt="Steadily.me Logo" className="w-full h-full object-contain rounded-lg md:rounded-xl" />
        </div>
        <span className="hidden sm:inline text-xl md:text-2xl font-bold font-serif text-[var(--color-ink-main)] tracking-tight">
          Steadily.me
        </span>
      </Link>

      <div className="flex items-center gap-3 sm:gap-6 font-serif font-bold text-sm sm:text-base">
        {NAV_LINKS.map(link => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) =>
              `group relative px-1 py-2 transition-colors ${
                isActive ? 'text-[var(--color-ink-main)]' : 'text-[var(--color-ink-light)] hover:text-[var(--color-ink-main)]'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span className="relative z-10">
                  <span className="hidden sm:inline">{link.label}</span>
                  <span className="sm:hidden">{link.short}</span>
                </span>
                <span
                  className={`${UNDERLINE} ${isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}`}
                  aria-hidden="true"
                />
              </>
            )}
          </NavLink>
        ))}
        <Link to="/login" className="group relative px-1 py-2 text-[var(--color-ink-main)]">
          <span className="relative z-10 flex items-center gap-2">
            Login <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </span>
          <span className={`${UNDERLINE} scale-x-0 group-hover:scale-x-100`} aria-hidden="true" />
        </Link>
      </div>
    </nav>
  );
}

export default SiteHeader;
